import ExperienceCard from "../components/ExperienceCard";
import { motion } from 'framer-motion';



const experiences = [
  {
    company: 'FlyBoku',
    role: 'Frontend Engineer',
    duration: 'March 2024 - Present',
    description: [
      'Collaborated with UX/UI designers to develop responsive, user-centric interfaces using Chakra UI.',
      'Improved the flight booking service, ensuring a seamless booking experience.',
    ],
  },
  {
    company: 'AllDAO',
    role: 'Software Engineer',
    duration: 'Feb 2024 - May 2024',
    description: [
      'Co-developed and deployed secure, well-audited smart contracts, focusing on quality and security.',
      'Built and integrated the frontend with Wagmi for seamless smart contract interactions.',
    ],
  },
  {
    company: 'Treshub',
    role: 'Web Developer',
    duration: 'Feb 2023 - Dec 2023',
    description: [
      'Built API endpoints using nodejs(express)',
      'Developed visually appealing user interfaces using Ant Design',
    ],
  },
  {
    company: 'Ruffwal',
    role: 'Frontend Developer Intern',
    duration: 'April 2022 - Oct 2022',
    description: [
      `UI Consistency:</strong> Ensured consistency in user interfaces by using Bootstrap's grid system and reusable UI components to maintain design uniformity`,
      'Developed visually appealing user interfaces using Ant Design',
    ],
  },
];
const ExperienceSection = () => {
  const sectionVariants = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        when: 'beforeChildren',
      },
    },
  };

  const lineVariants = {
    hidden: { scaleX: 0 },
    visible: { scaleX: 1, transition: { duration: 0.5 } },
  };

  const headerVariants = {
    hidden: { opacity: 0, y: -30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <motion.section
      className='bg-[#080808] text-white py-12 px-6 min-h-[100vh]'
      initial='hidden'
      whileInView='visible'
      viewport={{ once: true, amount: 0.2 }}
      variants={sectionVariants}
    >
      <div className='max-w-5xl mx-auto'>
        {/* Section Header */}
        <div className='flex items-center px-[2%] mt-[100px]'>
          <motion.div
            className='w-full h-[1px] bg-[#353535]'
            variants={lineVariants}
          ></motion.div>
          <motion.p
            className='text-xl md:text-3xl text-center font-bold mx-3 text-[#4d760c] mb-4'
            variants={headerVariants}
          >
            Experience
          </motion.p>
          <motion.div
            className='w-full h-[1px] bg-[#353535]'
            variants={lineVariants}
          ></motion.div>
        </div>

        {/* Experience Cards */}
        <motion.div className='space-y-8'>
          {experiences.map((exp, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2, duration: 0.5 }}
            >
              <ExperienceCard {...exp} />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.section>
  );
};

export default ExperienceSection;